export default (axios, baseURL) => async (params, clientSid) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/zip`;

  const axiosConfig = {
    method: 'GET',
    baseURL,
    url,
    params
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
